import { wait } from 'src/utils/wait'

/**
 * Allows to limit the execution number of an asynchronous function in an interval and to automatically restart
 * the last call at the end of the interval if it was prevented.
 * This behavior is different from throttle implementations you might find online.
 * With this implementation, intermediate calls are simply ignored.
 * @param fn
 * @param ms
 * @param leading
 * @returns {(function(...[*]): (null))|*}
 */
export function throttlePromise(fn, ms, leading = true) {
  let queuedFnCall = false
  let queuedFnCallThis = null
  let queuedFnCallArgs = null
  let runningPromise = null

  function invokeFn(fnThis, fnArgs, leading) {
    if (runningPromise === null) {
      runningPromise = new Promise((resolve, reject) => {
        const promises = [
          wait(ms)
        ]

        if (leading) {
          promises.push(fn.apply(fnThis, fnArgs))
        } else {
          queuedFnCall = true
        }

        Promise.allSettled(promises)
          .then(results => {
            runningPromise = null

            if (queuedFnCall) {
              queuedFnCall = false
              invokeFn(queuedFnCallThis, queuedFnCallArgs, true).then(resolve).catch(reject)
            } else if (results[1].status === 'fulfilled') {
              resolve(results[1].value)
            } else {
              reject(results[1].reason)
            }
          })
      })
    } else {
      queuedFnCall = true
      queuedFnCallThis = fnThis
      queuedFnCallArgs = fnArgs
    }

    return runningPromise
  }

  return function (...args) {
    return invokeFn(this, args, leading)
  }
}
